/** Encodes a sensitive string (like a passphrase) for URL safety. */
export const encodePassphrase = (passphrase: string): string => encodeURIComponent(passphrase);

/** Decodes a URL-encoded string. */
export const decodePassphrase = (base64String: string): string => decodeURIComponent(base64String);

/** Generates a random alphanumeric string of the specified length. */
export const randomString = (length: number): string => {
  const characters = "abcdefghijklmnopqrstuvwxyz";
  return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join("");
};

/** Generates a short 8-character alphanumeric ID. */
export const generateShortId = (): string => Math.random().toString(36).substring(2, 10);

/** Converts a string to snake_case (e.g., "Hello World" -> "hello_world"). */
export const toSnakeCase = (input: string): string =>
  !input
    ? ""
    : input
        .normalize("NFKD")
        .replace(/\p{Diacritic}/gu, "")
        .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
        .replace(/[\s\-]+/g, "_")
        .replace(/[^A-Za-z0-9_]/g, "")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "")
        .toLowerCase();

/** Checks if the device has low hardware concurrency (likely low power). */
export const isLowPowerDevice = (): boolean => navigator.hardwareConcurrency < 6;
